import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Tarea/Edit/{id}',
  documento: 'crm',
  filas: ['140'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/TareaController.cs',
} satisfies RutaProd;
